export const LOGIN_API = "/v1/auth/login";
export const PROFILE_API = "/v1/profile/me";
export const SECURITY_API = "v1/auth";
